import { useQuery} from '@tanstack/react-query'
import { buildSingularResourcefulRequests } from '@utils/requests'

export function useOrganizationDashboardQuery(selectedPeriod, organization_id) {
  const basePath = `/api/organization_dashboard?scope=${selectedPeriod}&organization_id=${organization_id}`
  const dashboardRequests = buildSingularResourcefulRequests(basePath)

  const dashboardQuery = useQuery(['dashboardData', selectedPeriod], dashboardRequests.show)

  const isFetching = dashboardQuery.isFetching

  return {
    data: dashboardQuery.data,
    status: dashboardQuery.status,
    isFetching: isFetching,
  }
}
